import { useEffect, useRef, useState } from "react";

/** Comparsa morbida: immediata per ciò che è già in vista al caricamento, allo scroll per il resto. */
export const Reveal = ({ children, delay = 0, className = "" }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (el.getBoundingClientRect().top < window.innerHeight) { setVisible(true); return; }
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setVisible(true); io.disconnect(); }
    }, { rootMargin: "0px 0px -40px 0px" });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div ref={ref} className={`reveal ${visible ? "is-in" : ""} ${className}`} style={delay ? { transitionDelay: `${delay}s` } : undefined}>
      {children}
    </div>
  );
};

export const PageHero = ({ eyebrow, title, intro, testid }) => (
  <section className="pt-32 pb-16 sm:pt-40 sm:pb-24 container-x grid grid-cols-12 gap-x-8 gap-y-10" data-testid={testid}>
    <Reveal className="col-span-12 lg:col-span-8">
      {eyebrow && <p className="eyebrow mb-10 flex items-center gap-4"><span className="rule-gold" />{eyebrow}</p>}
      <h1 className="font-serif font-light text-[46px] sm:text-6xl lg:text-[72px] leading-[1.01] tracking-[-0.03em] text-ink">{title}</h1>
    </Reveal>
    {intro && (
      <Reveal delay={0.18} className="col-span-12 sm:col-span-10 lg:col-span-4 lg:self-end">
        <p className="text-stoneish font-light leading-[1.85] text-[15.5px] border-l border-oro/50 pl-6">{intro}</p>
      </Reveal>
    )}
  </section>
);
